import  { useEffect, useState } from 'react'
import HealthIncNotificaMessageBody from '../HealthIncNotificaMessageBody/HealthIncNotificaMessageBody';

function HealthIncNotificaForEmpForReturnedOrRefusedRelativesData({ data }) {

//====State start here====
const [showNotifica,setShowNotifica] = useState(false);
//====State end here=====

//====Event handler start here====
const checkStutsData = ()=>{
 for(let i = 0 ; i < data.length ; i++){
    if( data[i].status === "RETURNED" || data[i].status === "DENIED" ){
     setShowNotifica(true);
     return;
    }
 }
}
//====Event handler end here====

//====useEffect start here====
useEffect(()=>{
 if( data ){
    checkStutsData();
 }
},[ data ]);
//====useEffect end here====
  return (
    <>
   {
    ( showNotifica ) &&
    ( <div className='show_notifi_container'> 
      <HealthIncNotificaMessageBody
       notifText = {"يرجى مراجعة صفحة بيانات الاقارب لقد تم اعادة او رفض بعض البيانات من قبل الموظف المسؤول"} 
       btnText = {"انتقال"}
       btnLink = {"/emp/h_insurance_personal_data"}
       /> 
       </div>)
   }
   </>
  )
}

export default HealthIncNotificaForEmpForReturnedOrRefusedRelativesData;